import React, { useEffect, useState } from "react";
import { maskCpf, onlyNumbersInput } from "../../../util/mask";
import { IoClose, IoShieldCheckmarkOutline } from "react-icons/io5";
import { CodeInput, Input } from "../../ui/Input";
import { Button, TooltipButton } from "../../ui/Button";
import { FaCheck } from "react-icons/fa";

export const Step1Component = React.memo(({ onSetTypePerson }) => {
    return (
        <div className="flex flex-col gap-4 max-w-md mx-auto mt-10">
            <h1>Olá, para começar informe seus dados para ter acesso as melhores ofertas.</h1>
            <div className="hidden md:block bg-[#4b0082] text-white px-4 py-2 rounded-full mb-6">
                <span className="flex items-center gap-2"><IoShieldCheckmarkOutline size={20} />Você está em ambiente seguro</span>
            </div>
            <button onClick={() => onSetTypePerson('FGTS')} className="w-full border border-gray-300 rounded-2xl py-4 px-6 flex items-center justify-between hover:shadow transition">
                <span className="text-black font-medium">Trabalhador com saldo no FGTS</span>
                <span className="text-pink-600 text-xl">›</span>
            </button>

            <button onClick={() => onSetTypePerson('INSS')} className="w-full border border-gray-300 rounded-2xl py-4 px-6 flex items-center justify-between hover:shadow transition">
                <span className="text-black font-medium">Aposentado ou pensionista do INSS</span>
                <span className="text-pink-600 text-xl">›</span>
            </button>
        </div>
    );
});

export const Step2Component = React.memo(({ form, handleChange, errors, inputsPersonalData }) => {
    return (
        <React.Fragment>
            <h1>Olá, para começar informe seus dados para ter acesso as melhores ofertas.</h1>
            <div className="hidden md:block bg-[#4b0082] text-white px-4 py-2 rounded-full mb-6">
                <span className="flex items-center gap-2"><IoShieldCheckmarkOutline size={20} />Você está em ambiente seguro</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {Object.keys(form).map((field) => {
                    const inputInfo = inputsPersonalData.find(x => x.field === field);
                    const maxLength = inputInfo ? (field == "cpf" ?
                        14 : inputInfo.maxLength ?
                            inputInfo.maxLength ?? 255
                            : 255) : 255;
                    if (inputInfo)
                        return (
                            <div key={field}>
                                <Input
                                    onChange={handleChange}
                                    name={field}
                                    value={field == "cpf" ? maskCpf(form[field]) : form[field]}
                                    label={inputInfo?.label}
                                    maxLength={maxLength}
                                    placeholder={inputInfo?.placeholder}
                                    type='text'
                                    marginTop
                                />
                                {errors[field] && <p className="text-red-500 text-sm">{errors[field]}</p>}
                            </div>
                        );
                })}
            </div>
            <small style={{ fontSize: 9 }} className='text-gray-600 mt-10'>
                <p>
                    Ao tocar em “continuar”, você confirma que aceita a  <a className="underline hover:text-[#462A71] duration-500" target='_blank' href="/Política de Privacidade.pdf">Política de Privacidade</a>
                </p>
            </small>
        </React.Fragment>
    )
});

export const StepMfaComponent = React.memo(({ form, checkSMSToken }) => {
    const [timer, setTimer] = useState(300)

    const formatTime = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;

        const padded = (n) => String(n).padStart(2, "0");

        return h > 0
            ? `${h}:${padded(m)}:${padded(s)}`
            : `${padded(m)}:${padded(s)}`;
    };

    useEffect(() => {
        if (timer <= 0) return;

        const interval = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timer]);

    return (<React.Fragment>
        <h1>Verificação de segurança</h1>
        <h3 className="mb-2 text-gray-400">Digite o código enviado por SMS para {form.phone}</h3>
        <div className="hidden md:block bg-[#4b0082] text-white px-4 py-2 rounded-full mb-6">
            <span className="flex items-center gap-2"><IoShieldCheckmarkOutline size={20} />Você está em ambiente seguro</span>
        </div>
        <CodeInput onComplete={(code) => {
            checkSMSToken(code)
        }} />
        <br />
        <span>Não recebeu? <TooltipButton tooltip={timer === 0 ? <span>Clique para fazer uma nova solcitação!</span> : <span>Nova solicitação em: {formatTime(timer)} </span>} onClick={() => alert("Clicado!")}>
            <span className={`${timer === 0 ? 'underline hover:text-[#462A71] duration-500' : ''}`} style={{ cursor: timer !== 0 ? 'not-allowed' : 'pointer' }}>Clique aqui!</span>
        </TooltipButton>
        </span>
    </React.Fragment>);
});


export const Step3Component = React.memo(({ onSubmitPassword }) => {
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    const hasRepeatedDigits = (str) => {
        for (let i = 0; i < str.length - 1; i++) {
            if (str[i] === str[i + 1]) return true;
        }
        return false;
    };

    const hasSequentialNumbers = (str) => {
        for (let i = 0; i < str.length - 1; i++) {
            if (parseInt(str[i]) + 1 === parseInt(str[i + 1])) return true;
        }
        return false;
    };

    const validations = {
        onlyNumbers: /^\d*$/.test(password) && password !== "",
        noRepeated: !hasRepeatedDigits(password) && password !== "",
        noSequential: !hasSequentialNumbers(password) && password !== "",
    };

    const passwordsMatch = password === password2 && password.length > 0;
    const allValid = Object.values(validations).every(Boolean) && (passwordsMatch && password2.length > 0) && (password.length === 6);

    const getIcon = (rule) => (rule ? <FaCheck color="green" /> : <IoClose color="red" />);

    return (
        <React.Fragment>
            <h1 className="mt-2 mb-4 text-gray-400">Agora vamos definir sua senha!</h1>
            <Input
                onChange={e => setPassword(onlyNumbersInput(e.target.value))}
                value={password}
                label="Senha"
                type="password"
                maxLength={6}
            />
            <Input
                value={password2}
                onChange={e => setPassword2(onlyNumbersInput(e.target.value))}
                label="Confirmar sua senha"
                type="password"
                maxLength={6}
            />
            <span className="text-gray-400 mt-5">Regras para a senha</span>
            <ul className="text-xs">
                <li className={`flex items-center gap-1 ${password.length === 6 ? 'text-green-500' : 'text-red-500'}`}>
                    {getIcon(password.length === 6)} Conter 6 dígitos
                </li>
                <li className={`flex items-center gap-1 ${validations.onlyNumbers ? 'text-green-500' : 'text-red-500'}`}>
                    {getIcon(validations.onlyNumbers)}  Utilizar somente números
                </li>
                <li className={`flex items-center gap-1 ${validations.noRepeated ? 'text-green-500' : 'text-red-500'}`}>
                    {getIcon(validations.noRepeated)}  Não pode conter dois números repetidos em sequência (ex: 88, 11)
                </li>
                <li className={`flex items-center gap-1 ${validations.noSequential ? 'text-green-500' : 'text-red-500'}`}>
                    {getIcon(validations.noSequential)}   Não digitar números sequenciais (ex: 12, 34)
                </li>
                <li className={`flex items-center gap-1 ${(passwordsMatch && password2.length > 0) ? 'text-green-500' : 'text-red-500'}`}>
                    {getIcon(passwordsMatch && password2.length > 0)} As senhas devem ser iguais
                </li>
            </ul>
            <div className="mt-5 flex items-center justify-end w-full">
                <Button
                    onClick={e => onSubmitPassword(password, password2)}
                    disabled={!allValid}
                >
                    Enviar
                </Button>
            </div>
        </React.Fragment>
    );
});